<template>
  <div class="box">
    <a class="teacher-card" >
      <div class="teacher-cover">
        <div class="avator">
          <img :src="item.img_url" alt />
        </div>
        <div class="rights">
          <div class="name">{{item.name}}</div>
          <!-- <div class="scope">关注&nbsp;&nbsp;{{item.focus_num?item.focus_num: 0}}</div> -->
        </div>
      </div>
      <div class="teacher-details">
        <div class="brief" >{{item.brief}}</div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["item"],
  methods: {
    showContent(item){
      alert(item)
    },
    toPage(id) {
      this.$router.push({
        path: "/page/teacher_details",
        query: { id: id }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.teacher-card {
      display: block;
    border: 1px solid #ebebeb;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 274px;
    height: 200px;
    margin-bottom: 20px;
    margin-right: 20px;
    padding: 18px;
    -webkit-transition: 0.3s ease all;
    transition: 0.3s ease all;
    box-shadow: 0 4px 9px 0 rgba(96,96,96,0.11);
    background: #fff;
  &:hover {
    transform: translateY(-6px);
    -webkit-transform: translateY(-6px);
    -moz-transform: translateY(-6px);
    box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
    -webkit-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
    -moz-box-shadow: 0 26px 40px -24px rgba(0, 36, 100, 0.3);
  }
  .teacher-cover {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    border-bottom: 1px solid #ebebeb;
    padding-bottom: 16px;
    .avator {
      flex: 1;
      justify-content: center;
      align-items: center;
      width: 78px;
      height: 78px;
      position: relative;
      overflow: hidden;
      border-radius: 50%;
      -moz-border-radius: 50%;
      -webkit-border-radius: 50%;
      border: 1px solid #fff;
      img {
        position: absolute;
        left: 50%;
        top: 0;
        height: 100%;

        -webkit-transform: translate3d(-50%, 0, 0);
        -moz-transform: translate3d(-50%, 0, 0);
        -o-transform: translate3d(-50%, 0, 0);
        -ms-transform: translate3d(-50%, 0, 0);
        transform: translate3d(-50%, 0, 0);
      }
    }
    .rights {
      flex: 2;
      margin-left: 19px;
      .name {
        max-width: 130px;
        line-height: 23px;
        font-size: 16px;
        color: #333;
        overflow: hidden;
      }
      .scope {
        max-width: 130px;
        max-height: 31px;
        font-size: 12px;
        color: #999999;
        overflow: hidden;
      }
    }
    
    
  }
  .teacher-details {
    box-sizing: border-box;
    // height: 88px;
    background: #fff;
    .brief {
      // min-height: 75px;
      box-sizing: border-box;
      font-size: 14px;
      color: #989898;
      padding: 20px 20px 0 20px;
      overflow: hidden;
      // white-space:nowrap;
      text-overflow: ellipsis;
      overflow:hidden;
      text-overflow: ellipsis;
      display:-webkit-box;
      -webkit-line-clamp:2;		//在这里控制指定行数超出换行哦
      -webkit-box-orient:vertical;
      cursor: pointer;
    }
  }
}
</style>
